export default __webpack_public_path__ + "static/media/Alisha.79c68935.jpg";